import RoutesOptions from "../models/RoutesOptionsDTO";

class Routes {
    oficina: RoutesOptions;
    backoffice: RoutesOptions;
    users: RoutesOptions;
    settings: RoutesOptions;
    settingsv2: RoutesOptions;
    clients: RoutesOptions;
    projects: RoutesOptions;
    equipments: RoutesOptions;
    loanEquipments: RoutesOptions;
    parts: RoutesOptions;
    fileTypes: RoutesOptions;
    auditLogs: RoutesOptions;
    scheduler: RoutesOptions;
    auxiliaryEquipments: RoutesOptions;
    countries: RoutesOptions;
    Holidays: RoutesOptions;
    clientQuotations: RoutesOptions;
    supplierQuotations: RoutesOptions;
    reviewClientQuotations: RoutesOptions;
    maintenancePlans: RoutesOptions;
    kpis: RoutesOptions;
    deliveryNotes: RoutesOptions;
    deliveryNotesUnsubmitted: RoutesOptions;
    reminders: RoutesOptions;
    subcontractors: RoutesOptions;
    imports: RoutesOptions;
    status: RoutesOptions;
    suppliers: RoutesOptions;
    checkListModels: RoutesOptions;
    invalidToken: RoutesOptions;
    checkListModelTasks: RoutesOptions;
    version: RoutesOptions;
    counterTypes: RoutesOptions;

    constructor() {
        this.oficina = {
            details: "/workshop/assistance",
            create: "/workshop/assistance/create",
            list: "/workshop",
            list2: "workshop/assistances"
        }

        this.backoffice = {
            details: "/backoffice/assistance",
            create: "/backoffice/assistance/create",
            list: "/backoffice"
        }

        this.users = {
            list: "/users/",
            create: "/users/Create",
            details: "/user"
        }

        this.settings = {
            list: "/settings/",
            create: "/settings/create",
            details: "/setting"
        }

        this.settingsv2 = {
            list: "/settingsv2/",
            create: "/settingsv2/create",
            details: "/settingsv2"
        };        
        
        this.clients = {
            list: "/clients/",
            create: "/clients/create",
            details: "/client"
        }

        this.projects = {
            list: "/projects/",
            create: "/projects/create",
            details: "/project"
        }

        this.equipments = {
            list: "/equipments/",
            create: "/equipments/create",
            details: "/equipment"
        }

        this.loanEquipments = {
            list: "/loanEquipments/",
            create: "/loanEquipments/create",
            details: "/loanEquipment"
        }

        this.parts = {
            list: "/parts/",
            create: "/parts/create",
            details: "/part"
        }

        this.fileTypes = {
            list: "/fileTypes/",
            create: "/fileTypes/create",
            details: "/fileTypes",
        }

        this.auditLogs = {
            list: "/auditLogs/",
            create: "/auditLogs/create",
            details: "/auditLogs"
        }

        this.scheduler = {
            list: "/scheduler/",
            create: "/scheduler/create",
            details: "/scheduler"
        }

        this.auxiliaryEquipments = {
            list: "/auxiliaryEquipments/",
            create: "/auxiliaryEquipments/create",
            details: "/auxiliaryEquipment"
        }
        this.clientQuotations = {
            list: "/clientQuotations/",
            create: "/clientQuotations/create",
            details: "/clientQuotation/:id"
        }
        this.supplierQuotations = {
            list: "/supplierQuotations/",
            create: "/supplierQuotations/create",
            details: "/supplierQuotation/:id"
        }

        this.countries = {
            list: "/countries/",
            create: "/countries/create",
            details: "/country"
        }
        this.Holidays = {
            list: "/Holidays/",
            create: "/Holidays/create",
            details: "/Holiday"
        }
        this.reviewClientQuotations = {
            list: "/reviewQuotations/",
            create: "/reviewQuotation/create",
            details: "/reviewQuotation/:id"
        }
        this.invalidToken = {
            list: "/invalidToken/",
            create: "/invalidToken/create",
            details: "/invalidToken"
        }
        this.maintenancePlans = {
            list: "/maintenancePlans/",
            create: "/maintenancePlan/create",
            details: "/maintenancePlan"
        }
        this.kpis = {
            list: "/kpis/",
            create: "/kpis/AssistancesExecutionsWithTotalTimeOver7Hours",
            details: "/kpis/AssistancesDifferentStartEndDate",
            list2: "/kpis/BrandModel/",
            list3: "/kpis/AssistancesExecutionNotFinished/",
            list4: "/kpis/OpenAssistancesMoreThan10Days/",
            list5: "/kpis/Technicians/Dashboard",
            list6: "/kpis/Clients/Dashboard",
            list7: "/kpis/Client/AssistancesHistoryDashboard"
        }
        this.deliveryNotes = {
            list: "/deliveryNotes/",
            //Botão que esta no sitio habitual do create é para navegar para outra listagem de Guias de transporte não submetidas
            create: "/deliveryNotes/list",
            details: "/deliveryNotes"
        }
        this.deliveryNotesUnsubmitted = {
            list: "/deliveryNotesUnsubmitted/",
            create: "/deliveryNotesUnsubmitted/create",
            details: "/deliveryNotesUnsubmitted"
        }
        this.reminders = {
            list: "/reminders/",
            create: "/reminder/create",
            details: "/reminder"
        }
        this.subcontractors = {
            list: "/subcontractors/",
            create: "/subcontractor/create",
            details: "/subcontractor"
        }
        this.imports = {
            list: "/imports/",
            create: "/import/create",
            details: "/import"
        }
        ///?
        this.status = {
            list: "/status/",
            create: "/status/create",
            details: "/status"
        }

        this.suppliers = {
            list: "/suppliers/",
            create: "/suppliers/create",
            details: "/supplier"
        }
        this.checkListModels = {
            list: "/checkListModels/",
            create: "/checkListModels/create",
            details: "/checkListModels"
        }
        this.checkListModelTasks = {
            list: "/checkListModelTasks/",
            create: "/checkListModelTasks/create",
            details: "/checkListModelTasks"
        }
        this.version = {
            details: "/version",
            list: "/version",
            create: "/version"
        }

        this.counterTypes = {
            list: "/counterTypes/",
            create: "/counterTypes/create",
            details: "/counterTypes"
        }
    }
}

var RoutesObject = new Routes();
export default RoutesObject;
